// import {
//     CREATE_ORDER_REQUEST,
//     CREATE_ORDER_SUCCESS,
//     CREATE_ORDER_FAILURE,
//     VERIFY_PAYMENT_REQUEST,
//     VERIFY_PAYMENT_SUCCESS,
//     VERIFY_PAYMENT_FAILURE,
//   } from "../constants/action-types.js";
import { ActionTypes } from "../constants/action-types";
  
  const initialState = {
    loading: false,
    orderId: null,
    success: false,
    error: null,
  };
  
  export const paymentReducer = (state = initialState, action) => {
    switch (action.type) {
      case ActionTypes.CREATE_ORDER_REQUEST:
      case ActionTypes.VERIFY_PAYMENT_REQUEST:
        return { ...state, loading: true };
  
      case ActionTypes.CREATE_ORDER_SUCCESS:
        return { ...state, loading: false, orderId: action.payload.id };
  
      case ActionTypes.VERIFY_PAYMENT_SUCCESS:
        return { ...state, loading: false, success: true };
  
      case ActionTypes.CREATE_ORDER_FAILURE:
      case ActionTypes.VERIFY_PAYMENT_FAILURE:
        return { ...state, loading: false, error: action.payload };
  
      default:
        return state;
    }
  };
  